export default [
  {
    path: "/sso-config",
    name: "SsoConfig",
    component: () => import("@/views/Page/SsoConfig/SsoConfig.vue"),
    meta: {
      title: "SSO Config",
      requiresAuth: true,
    },
  },
];
